import { DESC } from 'NewAngular/constants/core.constants';
export const ADD_TO_WATCHLIST = 'add_to_watchlist';
export const CHANGE_TYPE = 'change_type';
export const DOWNLOAD_SOURCE_FILE = 'download_source_file';
export const EXPORT_HOLDINGS = 'export_holdings';
export const GENERATE_REPORT = 'generate_report';
export const UPLOAD_DATA = 'upload_data';
export const OVERVIEW = 'overview';
export const PUSH_TO_IREBAL = 'push_to_irebal';
export const REFRESH_SUB_MENU = 'refresh_sub_menu';
export const REFRESH = 'refresh';
export const AUTO_REFRESH = 'auto_refresh';
export const RESET = 'reset';
export const DELETE_MODEL_PORTFOLIO_ERROR_MESSAGE = 'An error occurred while deleting the model portfolio. Please try again or contact support.';
export const MODEL_PORTFOLIOS_LIST_DEFAULT_SORT_DIRECTIONS = { user_modify_date: DESC };
/**
 * This enum represents the possible valid values for sorting on the model portfolios list page.
 */
export var ModelPortfolioListPageSortColumn;
(function (ModelPortfolioListPageSortColumn) {
    ModelPortfolioListPageSortColumn["NAME"] = "name";
    ModelPortfolioListPageSortColumn["OWNER_NAME"] = "owner_name";
    ModelPortfolioListPageSortColumn["USER_MODIFY_DATE"] = "user_modify_date";
    ModelPortfolioListPageSortColumn["LABEL"] = "label";
})(ModelPortfolioListPageSortColumn || (ModelPortfolioListPageSortColumn = {}));
export const NEW_MODAL_CREATE_TITLE = 'Create a Blank Portfolio';
export const NEW_MODAL_CONVERSION_TITLE = 'Change Type for';
export const IREBAL_PUSH_ERROR_MESSAGES = {
    integration_authentication_failed: 'There was an error pushing the portfolio. Check that the Integration is active.',
    model_portfolio_not_allowed_in_holdings: 'The portfolio cannot have a mix of securities and portfolios in its holdings.',
    invalid_model_portfolio: 'The selected portfolio is not valid. Please contact support.',
    integration_invalid_response: 'Something went wrong, please try again or contact support.',
    portfolio_already_exists: 'This model name is already in use. Please try again with a different name.',
    unrecognized_security: 'The pushed portfolio contains unrecognized securities: ',
    name_too_long: 'The name of the portfolio should be no more than 50 characters.',
    description_too_long: 'The description of the portfolio should be no more than 100 characters.',
};
